<template>
    <div>
        <hts-modal
            size="small"
            :show="openModal && !visible"
            :auto-close="true">
            <p>
                Đang tính giá, vui lòng đợi trong giây lát
            </p>
            <progress class="progress w-full" />
        </hts-modal>

        <hts-drawer
            v-model="visible"
            :submit="submit"
            :title="$t('labels.quoteAdd')"
            :rules="cRules"
            :size="90">
            <div :style="{ minWidth: minWidthScroll }">
                <quote-add
                    v-if="openCreateQuote"
                    ref="quoteAdd"
                    :show-request-price="true"
                    :quote-request-id="quoteRequestId"
                    :quote-data="quoteData" />
            </div>

            <template #footer>
                <hts-form-button
                    icon-name="hi-check-icon"
                    color="primary"
                    type="submit"
                    @click="quoteAdd && quoteAdd.step !== 0 ? quoteAdd && quoteAdd.previousStep() : (visible = 0)">
                    {{ $t('labels.back') }}
                </hts-form-button>
                <hts-form-button
                    v-if="quoteAdd && quoteAdd.step < 2"
                    icon-name="hi-arrow-long-right-icon"
                    icon-position="right"
                    color="primary"
                    type="submit"
                    @click="quoteAdd && quoteAdd.nextStep()">
                    {{ $t('labels.next') }}
                </hts-form-button>
                <div
                    v-if="quoteAdd && quoteAdd.step === 2"
                    class="flex">
                    <hts-form-button
                        icon-name="hi-arrow-long-right-icon"
                        icon-position="right"
                        color="primary"
                        type="submit"
                        :disabled="loadingSubmitCreateQuote || quoteAdd.checkMarkupPricingSelection({ checkPermission: true })"
                        :loading="loadingSubmitCreateQuoteSendEmail"
                        @click="typeSubmit = 2">
                        {{ $t('labels.createAndSend') }}
                    </hts-form-button>

                    <hts-form-button
                        icon-name="hi-arrow-long-right-icon"
                        class="ml-5"
                        icon-position="right"
                        color="primary"
                        type="submit"
                        :disabled="loadingSubmitCreateQuoteSendEmail"
                        :loading="loadingSubmitCreateQuote"
                        @click="typeSubmit = 1">
                        {{ $t('labels.create') }}
                    </hts-form-button>
                </div>
            </template>
        </hts-drawer>

        <hts-modal
            title="Cảnh báo"
            :show="modals.price.show"
            @close="modals.price.show = false">
            <p v-if="modals.price.label">
                {{ modals.price.label }}
            </p>
            <div v-else>
                <div v-if="modals.price.msgCode === 59">
                    <p>
                        Hệ thống không thể tính toán đầy đủ giá cho các trái tuyến sau do thiếu thông tin tuyến:
                    </p>

                    <p
                        v-for="(label, index) in modals.price?.offLineRoutes || []"
                        :key="index">
                        - {{ label }}
                    </p>
                </div>
            </div>
        </hts-modal>

        <hts-modal
            title="Cảnh báo tuyến từ Map"
            :show="modals.priceRouteGGMap.show"
            type="confirm"
            :hide-close="true"
            :auto-close="true"
            @confirm="comfirmRouteGGMap"
            @hide="rejectRouteGGMap">
            <p v-if="modals.priceRouteGGMap.label">
                {{ modals.priceRouteGGMap.label }}
            </p>
            <div v-else>
                <div v-if="modals.priceRouteGGMap.msgCode === 61">
                    <p>
                        Thông tin tuyến chưa được vẽ đầy đủ trên hệ thống. Vui lòng xác nhận nếu bạn muốn tiếp tục tính toán giá dựa trên thông tin từ Google Maps cho các
                        trái tuyến sau:
                    </p>

                    <p
                        v-for="(label, index) in modals.priceRouteGGMap?.offLineRoutes || []"
                        :key="index">
                        - {{ label }}
                    </p>
                </div>

                <div v-if="modals.priceRouteGGMap.msgCode === 62">
                    <p>
                        Thông tin tuyến chưa được vẽ đầy đủ trên hệ thống. Vui lòng xác nhận nếu bạn muốn tiếp tục tính toán giá dựa trên thông tin từ Google Maps cho tuyến
                        {{ modals.priceRouteGGMap.route }} <span v-if="modals.priceRouteGGMap.offLineRoutes?.length">
                            và các trái tuyến sau:
                        </span>
                    </p>

                    <p
                        v-for="(label, index) in modals.priceRouteGGMap?.offLineRoutes || []"
                        :key="index">
                        - {{ label }}
                    </p>
                </div>
            </div>
        </hts-modal>
    </div>
</template>
<script lang="ts" setup>
import { IQuote } from '../-components/ignore/imports/form'
import QuoteAdd from '../../-components/add.vue'
import { $api } from '#imports'

import screen from '~/components/utils/screen'
const visible = ref(false)
const openModal = ref(false)
const emits = defineEmits(['refreshTables'])
const loadingSubmitCreateQuote = ref(false)
const router = useRouter()

const breakpoint = screen()
const minWidthScroll = computed(() => {
  return `${breakpoint.value.thresholds.sm + 100}px`
})

const props = defineProps({
  // sao khi tạo trong quote sẽ chuyển sang quote management page
  goToManagementPage: {
    type: Boolean,
    dafault: true
  }
})

const { goToManagementPage } = toRefs(props)

const modals = ref({
  price: {
    show: false,
    label: '',
    msgCode: 0,
    route: [],
    offLineRoutes: [[]]
  },
  priceRouteGGMap: {
    show: false,
    label: '',
    msgCode: 0,
    route: [],
    offLineRoutes: [[]]
  }
})

const handleSubmitCreateQuote = async (options: { [key: string]: any } = {}) => {
  loadingSubmitCreateQuote.value = true
  try {
    await handleSubmit(options)
    loadingSubmitCreateQuote.value = false
  } catch (e: any) {
    loadingSubmitCreateQuote.value = false
  }
}
const loadingSubmitCreateQuoteSendEmail = ref(false)
const handleSubmitCreateQuoteSendEmail = async (options: { [key: string]: any } = {}) => {
  loadingSubmitCreateQuoteSendEmail.value = true
  try {
    await handleSubmit(options)
    loadingSubmitCreateQuoteSendEmail.value = false
  } catch (e: any) {
    loadingSubmitCreateQuoteSendEmail.value = false
  }
}

const handleSubmit = async (options: { [key: string]: any } = {}) => {
  const result = quoteAdd.value ? await quoteAdd.value.handleCreateQuoteRequest(options) : null

  if (result) {
    visible.value = false
    openModal.value = false
    emits('refreshTables', result)
  }
}

const typeSubmit = ref(0) // 1 create quote 2 create quote send mail

const submit = async () => {
  switch (typeSubmit.value) {
  case 0:
    break
  case 1:
    await handleSubmitCreateQuote()
    nextTick(() => {
      goToManagementPage.value && router.push({ name: 'c-id-quote-management' })
    })
    typeSubmit.value = 0
    break
  case 2:
    await handleSubmitCreateQuoteSendEmail({ sendEmail: true })
    nextTick(() => {
      goToManagementPage.value && router.push({ name: 'c-id-quote-management' })
    })
    typeSubmit.value = 0
    break
  default:
    break
  }
}

const quoteData = ref<IQuote>({} as IQuote)

const quoteRequestId = ref('')
const quoteAdd = ref()
const open = async (id: string) => {
  openModal.value = true
  quoteRequestId.value = id
  await getQuotePriceData()
  visible.value = true
  openModal.value = false
}

const openCreateQuote = ref(false)

const getQuotePriceData = async () => {
  try {
    openCreateQuote.value = false
    const api = $urlClient.quote.getQuotePrice
    const data: any = await $api(api, { uriParams: { quoteRequestId: quoteRequestId.value } })
    const resData = data?.data?.value

    if (resData && resData.success) {
      quoteData.value = resData.data
      const alerts = resData.data.alerts
      const alertNotRoute = alerts.find((item: any) => item.alertType === 'notRoute')
      const alertPriceRouteGGMap = alerts.find((item: any) => item.alertType === 'routeGGMap')

      if (alertNotRoute) {
        modals.value.price.show = true
        modals.value.price.label = alertNotRoute.label
        modals.value.price.msgCode = alertNotRoute.msgCode
        modals.value.price.offLineRoutes = alertNotRoute.offLineRoutes?.map((item: string[]) => item.join(' >> ')) || []
      }

      if (alertPriceRouteGGMap) {
        quoteData.value.alerts = []
        modals.value.priceRouteGGMap.show = true
        modals.value.priceRouteGGMap.label = alertPriceRouteGGMap.label
        modals.value.priceRouteGGMap.msgCode = alertPriceRouteGGMap.msgCode
        modals.value.priceRouteGGMap.route = alertPriceRouteGGMap.route?.join(' >> ')
        modals.value.priceRouteGGMap.offLineRoutes =
          alertPriceRouteGGMap.offlineRoutes?.map((item: string[]) => {
            return item.join(' >> ')
          }) || []
      }

      openCreateQuote.value = true
    }
  } catch (e) {
    openCreateQuote.value = false
  }
}

const comfirmRouteGGMap = () => {
  quoteData.value.comfirmRouteGGMap = true
  modals.value.priceRouteGGMap.show = false
  quoteData.value.alerts = []
}
const rejectRouteGGMap = () => {
  quoteData.value.comfirmRouteGGMap = false
  modals.value.priceRouteGGMap.show = false
  quoteData.value.prices = quoteData.value.pricesNotRouteGGMap || []
  quoteData.value.priceOfflineFee = quoteData.value.priceOfflineFeeNotRouteGGMap || []
  quoteData.value.alerts = []

  const internal = quoteData.value.prices.find((item: any) => item.type === 'internal')

  if (!internal) {
    quoteData.value.alerts = [
      {
        alertType: 'notRoute',
        label: 'Hệ thống không thể tính toán giá nội bộ do thiếu thông tin tuyến.'
      }
    ]
    const alertNotRoute = quoteData.value.alerts?.find((item: any) => item.alertType === 'notRoute')
    modals.value.price.show = true
    modals.value.price.label = alertNotRoute.label
  }
}

const ruleCreateQuote = {
  effectiveFromDate: 'required|min_date:1970-01-01',
  effectiveToDate: 'min_date:1970-01-01'
}

const cRules = computed(() => {
  if (quoteAdd.value && quoteAdd.value.step === 2 && quoteAdd.value.dataCreateQuote.effectiveFromDate) {
    const rules: { [key: string]: any } = { ...ruleCreateQuote }

    const date = quoteAdd.value.dataCreateQuote.effectiveFromDate ? new Date(quoteAdd.value.dataCreateQuote.effectiveFromDate) : ''
    if (date && quoteAdd.value.dataCreateQuote.effectiveToDate) {
      date.setDate(date.getDate() + 1)
      rules.effectiveToDate = rules.effectiveToDate + `|min_date:${date.toISOString().split('T')[0]}`
    }
    return rules
  }
  return {}
})
defineExpose({
  open
})
</script>
